import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-notification-dialog',
    templateUrl: './notification-dialog.component.html',
    styleUrls: ['./notification-dialog.component.scss'],
    standalone: true,
    imports: [MatButton]
})
export class NotificationDialogComponent implements OnInit, OnDestroy {

  headerImage = '';
  title = '';
  buttonText = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>, public overlayContainer: OverlayContainer) {
    overlayContainer.getContainerElement().classList.remove('mini-calendar-dialog_overlay');
    overlayContainer.getContainerElement().classList.add('notification-dialog_overlay');
  }

  ngOnInit(): void {
    if (this.data.type === 'success') {
      this.title = 'Success!';
      this.headerImage = './../../../assets/images/backgrounds/success_header.png';
      this.buttonText = 'THANKS';
    }
    if (this.data.type === 'celebration') {
      this.title = 'Congratulations!';
      this.headerImage = './../../../assets/images/backgrounds/celebration_header.png';
      this.buttonText = 'THANK YOU';
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.overlayContainer.getContainerElement().classList.remove('notification-dialog_overlay');
  }

}
